import PinwheelModal from '@pinwheel/react-modal';

import type { PinwheelProps } from './types';

const Pinwheel = ({ linkToken, onExit, onSuccess, onError }: PinwheelProps) => {
    return (
        <PinwheelModal
            linkToken={linkToken}
            open={true}
            onExit={(_payload) => {
                onExit();
            }}
            onSuccess={(payload) => {
                onSuccess(payload);
            }}
            onError={(payload) => {
                onError(payload);
            }}
        />
    );
};

export default Pinwheel;
